  <template>
    <div style="min-height:90vh;">
      <bread-crumbs :links="breadsCrumbs"></bread-crumbs>
      <v-card flat style="border-radius:10px;margin-bottom:30px;">
        <v-container style="max-width:700px;margin:0 auto;">
          <v-flex xs12>
            <p style="text-align:center;margin:30px 0;">
            </p>
          </v-flex>
          <v-flex xs12 class="subheading myblock">
            <h2 class="headline primary--text font-weight-bold">
              辛くて、いいものと出会おう
            </h2>
            <p>単に辛いだけではダメ。辛くて、いいねと言える食べものに出会いたい。全ての激辛好きが想っているそんな願いを少しだけ手助けしたい。そんなWebサービスを作りました。「カライイネ」は激辛好きな人々が、自分が辛くて、いいね！と思ったものを紹介し、お互いにカライイネを送り合う。そんなサイトです。</p>
          </v-flex>
          <v-flex xs12 class="subheading myblock">
            <h2 class="headline primary--text font-weight-bold">
              気軽に激辛情報を投稿しあう「カラログ」
            </h2>
            <p>
              辛いもの好きな人は多いし、辛い美味しい食べ物は増えてきています。しかし、新しい辛い食べ物との出会いは難しくないですか？
              新商品が発売されたり新しいお店ができても辛いのかも美味しいのかもわからない。結局、失敗したくないのでいつもの味に...それって勿体ないですよ！！<br><br>
              激辛好き同士で情報を交換しましょう。辛いもの好きなあなたが出会う辛いものとの出会いをカラログとして残そう！きっと激辛好きな誰かにとって貴重な情報になるはずです。
            </p>
          </v-flex>
          <v-flex xs12 class="subheading myblock">
            <h2 class="headline primary--text font-weight-bold" style="margin-bottom:10px;">
              世界初！「辛さ比較」
            </h2>
            <p style="text-align:center;">
              <img src="@/assets/img/karasahikaku.png" style="width:100%;max-width:500px;" alt="辛さ比較">
            </p>
            <p>
              カライイネでは、<span class="red--text">辛さの相対評価「辛さ比較」</span>を行うことができます！
              <br>
              カラログを登録する際に、あなたが今までカラログってきた食品と辛さを比較します。そうすることで、あなたが食べたカライモノの<span class="red--text">辛いランキング</span>が出来上がります。
              カライイネに参加したカライモノズキな人たちも自分の辛いランキングを作る。それを全部合算する。すると、<span class="red--text">世界のカライモノランキング</span>を作ることができる。そんな世界を目指しています。
            </p>
          </v-flex>
          <v-flex xs12 class="subheading myblock">
            <h2 class="headline primary--text font-weight-bold">
              目標は「辛さ検索」
            </h2>
            <p>
              カライイネの最大の目標。それは<span class="red--text">辛さ検索</span>です。
              「<span class="primary--text">誰もが自分の好みの辛さと出会える世界</span>」を目指します。<br><br>
              カライイネは単に辛さの頂点を追及するサイトではありません。人によって辛さの好みは異なるもの。あなたに合うカライモノに出会えなければ意味がない！<br><br>
              あなたが食べたことある食品の辛さと同じくらい辛い食品、ちょっと辛い食品、辛さが控えめの食品などなど、あなたが知っているタベモノを軸に食品の辛さを知ることができる世界を目指します。
            </p>
          </v-flex>
          <v-flex xs12 class="subheading myblock">
            <h2 class="headline primary--text font-weight-bold">
              助けてください！
            </h2>
            <p>
              ここまでお読みいただき、本当にありがとうございます。<br><br>
              カライイネはまだまだ始まったばかり...目標である辛さ検索の実現には多くの激辛好きのみなさまの協力が何よりも大切です。我々運営チームはカライイネを使ってくださる激辛好きな皆さまのカラログを宝物のように扱い、みなさまの貴重なご意見に真摯に対応し続けます。だから助けてください！辛いものの情報をどうかお寄せください！！
              <br><br>
              カライイネへのご要望、お問い合わせもお待ちしています！
            </p>
          </v-flex>
          <v-flex xs12 class="subheading myblock">
            <p>
              <span class="primary--text">すべては、あなたと多くのカライイネの出会いのために</span>
            </p>
            <p>
              <span class="primary--text">2019年10月&nbsp;カライイネ運営チーム</span>
            </p>
          </v-flex>
          <sns-buttons></sns-buttons>
        </v-container>
      </v-card>
      <v-card flat style="border-radius:10px;margin-bottom:30px;">
        <v-container style="max-width:700px;margin:0 auto;">
          <v-flex xs12 class="subheading myblock">
            <h2 class="headline font-weight-bold">
              Special Thanks !!
            </h2>
            <p>カライイネの開発、運営においてお世話になった方々です！！</p>
          </v-flex>
          <v-flex xs12 class="subheading myblock">
            <h3 class="font-weight-bold primary--text">
              なつさん（@sunaganatsuko）
            </h3>
            <p>
              カライイネの公式アカウントのイラストをご提供いただきました！！
            </p>
            <p style="text-align:center;">
              <a href="https://twitter.com/sunaganatsuko" target="_blank">
              <v-avatar size="200">
                <img src="@/assets/img/natsusan.jpg" alt="なつさんプロフィール画像"/>
              </v-avatar>
              </a>
            </p>

            <h3 class="font-weight-bold primary--text" style="margin-top:30px;">
              ザ・激辛日記！！さん
            </h3>
            <p>
              飲食店情報の初期データをご提供いただきました！！
            </p>
            <p style="text-align:center;">
              <a href="https://zakara.club/" target="_blank">
              <v-avatar size="200">
                <img src="@/assets/img/gekikaranikki.jpg" alt="ザ・激辛日記！！さん"/>
              </v-avatar>
              </a>
            </p>

          </v-flex>
          <sns-buttons></sns-buttons>
        </v-container>
      </v-card>
      
    </div>
  </template>

  <script>
  import BreadCrumbs from '@/components/common/BreadCrumbs.vue'
  import SnsButtons from '@/components/common/SnsButtons.vue'

  export default {
    name: 'about',
    data () {
      return {
        breadsCrumbs: [{name: 'home', meta: {pageName: 'トップ'}}, {name: 'about', meta: {pageName: 'カライイネとは？'}}]
      }
    },
    components: {
      BreadCrumbs,
      SnsButtons
    },
    mounted () {
      window.scrollTo(0, 0)
    },
    head: {
      title () {
        return {
          inner: 'カライイネとは？',
          separator: ' ',
          complement: 'カライイネは激辛・旨辛グルメ特化のSNS！'
        }
      },
      meta () {
        return [
          {name: 'description', content: '激辛グルメSNS「カライイネ」とはどんなWebサービスなのか。なぜ創ろうと想ったのか記載しました。'}
        ]
      }
    }
  }
  </script>
  <style scoped>
    .myblock {
      line-height: 2;
      margin-bottom:36px;
    }
  </style>